<template>
    <div>
        <el-row>
            <el-col :span="6">
                <!-- KPI部门树 -->
                <el-container>
                    <el-aside style="width:100%;">
                        <el-input size="small" style="margin-bottom:12px;margin-top:12px;" placeholder="输入关键字进行过滤"
                            v-model="filterText"></el-input>
                        <el-tree class="filter-tree" :data="data" :props="defaultProps" node-key="id"
                            @node-click="handleNodeClick" :filter-node-method="filterNode" ref="tree">
                            <span class="custom-tree-node" slot-scope="{ node, data }">
                                <span style="font-size:14px;height:40px;">{{ node.label }}</span>
                            </span>
                        </el-tree>
                    </el-aside>
                </el-container>
            </el-col>
            <el-col :span="17" style="float:right;margin-top:12px;" :class="isShowList ? 'show' : 'hidden'">
                <!-- 搜索条件 -->
                <el-row class="viewKPITitle">
                    <el-col style="margin-right:40px;" :class="pType == 0 ? '' : 'hidden'" :span="4">
                        <el-date-picker size="small" v-model="dateMonth" type="month"
                            placeholder="选择月"></el-date-picker>
                    </el-col>
                    <el-col style="margin-right:40px;" :class="pType == 0 ? 'hidden' : ''" :span="4">
                        <el-date-picker size="small" v-model="yearValue" type="year" placeholder="选择年">
                        </el-date-picker>
                    </el-col>
                    <el-col style="margin-right:40px;" :class="pType == 0 ? 'hidden' : ''" :span="4">
                        <el-select size="small" v-model="dateJidu" placeholder="请选择季度">
                            <el-option label="Q1" value="Q1"></el-option>
                            <el-option label="Q2" value="Q2"></el-option>
                            <el-option label="Q3" value="Q3"></el-option>
                            <el-option label="Q4" value="Q4"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="4">
                        <el-input placeholder="人员姓名" size="small" v-model="title"></el-input>
                    </el-col>
                    <el-col :span="2">
                        <el-button icon="el-icon-search" size="small" @click="SearchByName"></el-button>
                    </el-col>
                    <!-- <el-col :class="isShowSend?'show':'hidden'" :span="1">
                        <el-button style="height:40px;" size="small" type="primary" plain @click="sendKPI">发送KPI</el-button>
                    </el-col> -->
                </el-row>
                <!-- 头部信息 -->
                <el-row>
                    <!-- 考核列表信息 -->
                    <el-table border :data="AllKPIInfo" style="width: 100%;margin-top:20px;" v-loading="loading"
                        size="small">
                        <el-table-column min-width="20" prop="sysUser.TrueName" label="被考核者姓名"></el-table-column>
                        <el-table-column min-width="20" prop="sysUser.MainDeptsName" label="所属部门"></el-table-column>
                        <el-table-column min-width="20" prop="sysUser.Duty" label="被考核者岗位"></el-table-column>
                        <el-table-column min-width="15" prop="userKPI[0].Period" label="考核周期"></el-table-column>
                        <el-table-column min-width="15" prop="KPIScode" label="总分"></el-table-column>
                        <el-table-column min-width="10" label="操作">
                            <template slot-scope="scope">
                                <el-button type="text" @click="handleClickRow(scope.row)" size="small">详情</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-row>

                <el-row style="margin-top:5px;">
                    <el-col :span="24">
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page="pageIndex" :page-sizes="pageSizes" :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper" :total="totalCount"
                            style="float:right"></el-pagination>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>

        <el-dialog width="70%" :title="dialagTitle" :visible.sync="dialogVisible">
            <div class="viewKPITitle">
                <el-row style="margin-top:10px;">
                    <el-col :span="6">
                        <span v-if="KPIItems.length > 0">被考核者姓名：{{ PersonKPI.userName }}</span>
                    </el-col>
                    <el-col :span="6">
                        <span v-if="KPIItems.length > 0">被考核者岗位：{{ PersonKPI.duty }}</span>
                    </el-col>
                    <el-col :span="6">
                        <span v-if="KPIItems.length > 0">被考核者工号：{{ PersonKPI.list[0].UserCode }}</span>
                    </el-col>
                    <el-col :span="6">
                        <span v-if="KPIItems.length > 0">考核周期：{{ PersonKPI.period }}{{ pType == 0 ? '月' : '季度' }}</span>
                    </el-col>
                </el-row>
                <el-row style="margin-top:10px;">
                    <el-col :span="6">
                        <span v-if="KPIItems.length > 0">考核者姓名：{{ PersonKPI.leadName }}</span>
                    </el-col>
                    <el-col :span="6">
                        <!-- {{viewKPITitle.Period}}{{viewKPITitle.PeriodType==1?'季度':'月'}} -->
                        <span v-if="KPIItems.length > 0">考核者岗位：{{ AllKPIInfo.leadDuty }}</span>
                    </el-col>
                </el-row>
            </div>
            <el-divider></el-divider>
            <el-table border :data="KPIItems" show-summary style="width: 100%;margin-top:20px;" v-loading="loading"
                size="small">
                <el-table-column min-width="20" prop="KPI" label="KPI名称"></el-table-column>
                <el-table-column min-width="10" prop="KPIWeight" label="KPI权重"></el-table-column>
                <el-table-column prop="Explain" min-width="20" label="指标说明"></el-table-column>
                <el-table-column prop="Contents" min-width="24" label="考核细则"></el-table-column>
                <el-table-column min-width="10" label="周期">
                    <template slot-scope="scope">{{ scope.row.PeriodType == 0 ? '月度' : '季度' }}</template>
                </el-table-column>
                <el-table-column prop="Execution" min-width="30" label="完成情况"></el-table-column>
                <el-table-column prop="SelfScore" min-width="10" label="自评评分"></el-table-column>
                <el-table-column prop="LeadScore" min-width="10" label="直属领导评分"></el-table-column>
            </el-table>
        </el-dialog>

    </div>
</template>

<script>
import { Decrypt, Encrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";
import { GetCurrentUserInfo } from "../../until/ZeusApiSDK/Logic/HomeLogic";
import { GetTreeDeptsData, GetChargeDeptsByUserCode, GetPageUserKPIByDeptId, SendFrameResult, GetKPIScore, GetMyKPI } from "../../until/ZeusApiSDK/Logic/KPILogic";
export default {
    props: {
        pt: {
            Type: Number
        },
        activeName: {
            Type: String
        }
    },
    watch: {
        //树状结构搜索
        filterText(val) {
            this.$refs.tree.filter(val);
        }
    },
    data() {
        return {
            isShowList: false,//是否显示右边菜单
            loading: false,
            data: [],//树形结构列表
            defaultProps: {
                children: 'nodes',
                label: 'text',
                disabled: 'type'
            },
            currentRole: {},//获取当前用户角色
            currentUser: {},//获取当前用户
            FrameClickID: '',//部门id
            filterText: '',
            operationFrameList: '',//当前操作部门列表
            operationFrameId: '',//当前操作部门id
            deptModel: {},//当前操作部门
            pageSizes: [10, 20, 50, 100, 200],
            pageSize: 10,
            pageIndex: 1,
            totalCount: 0,
            title: '',//人员姓名
            AllKPIInfo: [],//获取KPI列表
            pType: this.pt,//0月度  1季度
            thisperiod: '',//当前操作周期
            yearValue: '',//季度选择年
            year: '',//选择年
            month: '',//选择月
            dateMonth: '',//当前选择月份
            dateJidu: '',//季度
            dialogVisible: false,
            dialagTitle: '绩效详情',
            KPIItems: [],
            PersonKPI: [],
        }
    },
    created() {
        //获取当前用户
        this.getCurrentUser();
        //获取当前用户角色
        this.getCurrentRole();
        //获取当前操作部门
        this.getCurrentDept();
        //获取部门树状结构
        this.getTreeDeptsData();

    },
    methods: {
        //获取当前用户
        getCurrentUser: function () {
            var userinfo = window.sessionStorage.getItem("userinfo");
            userinfo = JSON.parse(Decrypt(userinfo));
            this.currentUser = userinfo;
        },
        //获取当前用户角色
        getCurrentRole: function () {
            var currentUserRole = window.sessionStorage.getItem("CurrentUserRole");
            this.currentRole = JSON.parse(Decrypt(currentUserRole));
        },
        //获取当前操作部门
        getCurrentDept: function () {
            var deptModelStory = window.sessionStorage.getItem("deptModel");
            if (deptModelStory == '' || deptModelStory == null || deptModelStory == 'undefined') {
                GetChargeDeptsByUserCode(this.currentUser.UserCode).then(res => {
                    if (res.list.length > 0) {
                        var dept = {
                            value: res.list[0].Id,
                            label: res.list[0].ClassName
                        }
                        //将加密后的操作部门保存到session中
                        window.sessionStorage.setItem(
                            "deptModel",
                            Encrypt(JSON.stringify(dept))
                        );
                        this.deptModel = dept;
                        deptModelStory = window.sessionStorage.getItem("deptModel");
                    } else {
                        var dept = {
                            value: '',
                            label: ''
                        }
                        this.deptModel = dept;
                    }
                });
            } else {
                this.deptModel = JSON.parse(Decrypt(deptModelStory));
            }
        },
        //搜索条件
        SearchByName: function () {
            this.loading = true;
            if (this.pType == 0) {
                //获取的年月需要转换
                this.year = this.dateMonth.getFullYear();
                this.month = this.dateMonth.getMonth() + 1;
                this.thisperiod = this.month;
            }
            else {
                //季度直接使用 
                this.month = this.dateJidu;
                this.year = this.yearValue.getFullYear();
                this.thisperiod = this.month;
            }
            this.getFrameKpiScoreList();
            if (this.totalCount <= 0) {
                if (this.FrameClickID == '' || this.FrameClickID == null || this.FrameClickID == 'undefined') {
                    this.$message({
                        message: '请选择查询部门',
                        type: 'success'
                    });
                    this.loading = false;
                } else {
                    this.$message({
                        message: '暂无数据',
                        type: 'success'
                    });
                }

            }
        },
        //获取操作周期
        getThisPeriod: function () {
            var thisperiod = '';
            var month = new Date().getMonth() + 1;
            if (this.pType == 1) {
                //季度  上个季度
                if (month >= 1 && month <= 3) {
                    thisperiod = 'Q4';
                }
                else if (month >= 4 && month <= 6) {
                    thisperiod = 'Q1';
                }
                else if (month >= 7 && month <= 9) {
                    thisperiod = 'Q2';
                }
                else if (month >= 10 && month <= 12) {
                    thisperiod = 'Q3';
                }
            } else {
                //月度  上月
                thisperiod = month - 1;
            }

            this.thisperiod = thisperiod;
        },
        //获取部门树状结构
        getTreeDeptsData: function () {
            //如为管理员则查看所有部门列表
            if (this.currentRole.Key == 'admin') {
                this.deptModel.value = '09308a98-76a5-4fd8-b810-ddd76d37fe4b';
            }
            GetTreeDeptsData(this.deptModel.value, this.currentRole.Key).then(res => {
                this.loading = false;
                this.data = JSON.parse(res);
            })
        },
        //根据部门获取KPI评分列表
        getFrameKpiScoreList: function () {

            if (this.dateMonth || (this.dateJidu && this.yearValue)) {
                if (this.pType == 0) {
                    //获取的年月需要转换
                    this.year = this.dateMonth.getFullYear();
                    this.month = this.dateMonth.getMonth() + 1;
                    this.thisperiod = this.month;
                }
                else {
                    //季度直接使用 
                    this.month = this.dateJidu;
                    this.year = this.yearValue.getFullYear();
                    this.thisperiod = this.month;
                }
            }
            else {
                var date = new Date();
                this.year = date.getFullYear();
                if (!this.thisperiod) {
                    //获取操作周期
                    this.getThisPeriod();
                }

                //跨年设置
                if (this.thisperiod == 0 || this.thisperiod == 'Q4') {
                    this.year = this.year - 1;
                }
                if (this.thisperiod == 0) {
                    this.thisperiod = 12;
                }
            }

            console.log('this.year', this.year);
            console.log('this.thisperiod', this.thisperiod);
            GetKPIScore(this.pageIndex, this.pageSize, this.thisperiod, this.FrameClickID, this.pType, this.year, this.title).then(res => {
                // if(res.totalCount<=0){
                //     this.$message({
                //         message: '暂无数据',
                //         type: 'success'
                //     });

                //     return false;
                // }
                this.AllKPIInfo = res.List;
                console.log('AllKPIInfo', this.AllKPIInfo)
                this.loading = false;
                this.totalCount = res.TotalCount;
            });
        },
        //节点点击事件
        handleNodeClick(data) {
            this.FrameClickID = data.FrameID;
            this.loading = true;
            this.isShowList = true;

            //根据部门获取KPI列表
            this.getFrameKpiScoreList();
        },
        filterNode(value, data) {
            if (!value) return true;
            return data.text.indexOf(value) !== -1;
        },
        //分页条件搜索
        handleSizeChange(val) {
            this.pageSize = val;
            this.getFrameKpiScoreList();
        },
        handleCurrentChange(val) {
            this.pageIndex = val;
            this.getFrameKpiScoreList();
        },
        //查看人员详情
        handleClickRow: function (data) {
            console.log('row', data);
            var kpiName = '';
            var pType = '';
            var month = '';
            var year = '';
            if (data.userKPI.length > 0) {
                kpiName = data.userKPI[0].PeriodType == 0 ? '月' : '季度';
                pType = data.userKPI[0].PeriodType;
                month = data.userKPI[0].Period;
                year = data.userKPI[0].CreateTime.split('-')[0];
            }

            this.dialogVisible = true;
            this.dialagTitle = data.sysUser.TrueName + data.userKPI[0].Period + kpiName + '绩效详情';
            var userCode = data.sysUser.UserCode;
            GetMyKPI(userCode, pType, month, year).then(res => {
                this.PersonKPI = res;
                this.KPIItems = res.list;
                this.loading = false;
            });
        }
    }
}
</script>
<style lang="less" scoped>
.show {
    display: block;
}

.hidden {
    display: none;
}
</style>
